import { useRepeatingTasks as _useRepeatingTasks } from '@griply/hooks';
import { RepeatingTask } from '@griply/types';
import { DeletedFilter } from '@griply/utils';
import { TaskType } from 'shared/types/task-base';

import { useAllTasksOfType } from './use-all-tasks-of-type';

export const useAllRepeatingTasks = (
  deletedFilter: DeletedFilter = DeletedFilter.ExcludeDeleted,
): RepeatingTask[] => {
  const tasks = useAllTasksOfType(TaskType.Repeating, deletedFilter);

  return _useRepeatingTasks({ tasks });
};
